import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d0c0096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-before-upload" }
const _hoisted_2 = { class: "note-header" }
const _hoisted_3 = { class: "note-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "note-info-text" }, "笔记攻略", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-upload-title" }, "上传笔记", -1))
const _hoisted_6 = { class: "m-upload-desc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, "上传学习笔记，获得" + _toDisplayString($props.parentInfo?.difficulty || 3) + "星卡牌", 1),
        _createElementVNode("div", {
          class: "note-info",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openNoteStrategy && $setup.openNoteStrategy(...args)))
        }, [
          _createVNode(_component_van_icon, { name: "question-o" }),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", {
        class: "u-upload-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.callUploadAction && $setup.callUploadAction(...args)))
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(" 上传笔记批改通过后，将获得" + _toDisplayString($props.parentInfo?.difficulty || 3) + "星卡牌，", 1),
        _hoisted_7,
        _createTextVNode("并有机会选为笔记范例哦～ ")
      ])
    ]),
    _createVNode(_component_aio_confirm, {
      visible: $setup.confirmVisible,
      confirmInfo: $setup.confirmInfo
    }, null, 8, ["visible", "confirmInfo"])
  ], 64))
}